import { Cookies } from 'react-cookie';
import { CommonPageProps } from '@/shared/lib/types';
import { getSiteSettings } from './site-settings';
import { getSocnets } from './socnets';

export const getCommonPageProps = async (cookies?: Partial<{ [key: string]: string }>): Promise<CommonPageProps> => {
    const [siteSettings] = await Promise.all([
        getSiteSettings({
            params: {
                keys: [
                    'contacts_default_document_oferta',
                    'contacts_default_phone',
                    'contacts_default_email',
                    'contacts_default_support_link',
                    'contacts_default_postal_сode',
                    'contacts_default_city',
                    'contacts_default_street',
                    'contacts_default_location',
                    'footer_default_form_text',
                ],
            },
        }),
    ]);

    const address = [
        siteSettings.data?.contacts_default_postal_сode,
        siteSettings.data?.contacts_default_city,
        siteSettings.data?.contacts_default_street,
        siteSettings.data?.contacts_default_location,
    ]
        .filter(Boolean)
        .join(', ');

    return {
        meta: {
            baseTitle: '',
            description: '',
            ogImage: '/img/og-image.jpg',
        },
        cookies: cookies ? new Cookies(cookies).getAll() : null,
        breadcrumbs: [],
        footerData: {
            formText: siteSettings.data?.footer_default_form_text || '',
            address: address || '',
            phone: siteSettings.data?.contacts_default_phone || '',
            email: siteSettings.data?.contacts_default_email || '',
            socialLinks: [
                {
                    icon: `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.9519 1.38517L14.3857 13.1038C14.1965 13.9347 13.6858 14.1363 12.9733 13.7453L9.06412 10.9531L7.17888 12.7127C6.97081 12.9144 6.79426 13.0854 6.39073 13.0854L6.66816 9.23015L13.9128 2.88818C14.228 2.61935 13.8434 2.46661 13.4273 2.73544L4.47397 8.1976L0.61521 7.03063C-0.223375 6.77402 -0.24229 6.21802 0.791755 5.827L15.8674 0.193762C16.5673 -0.0506295 17.1789 0.358727 16.9519 1.38517Z" fill="#082E74"/>
                    </svg>
                    `,
                    href: 'https://t.me/oilgasforum_TNF',
                    name: 'Telegram',
                },
                {
                    icon: `<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.09718 3.1875H1.23776C0.706375 3.1875 0.600098 3.45055 0.600098 3.74134C0.600098 4.2594 1.23011 6.83087 3.53589 10.2309C5.07223 12.5536 7.23774 13.8125 9.20769 13.8125C10.3903 13.8125 10.5366 13.5324 10.5366 13.052V11.2965C10.5366 10.7373 10.6488 10.6254 11.0229 10.6254C11.2992 10.6254 11.7711 10.7704 12.8755 11.8897C14.1364 13.2175 14.3438 13.8125 15.0529 13.8125H16.9132C17.4446 13.8125 17.7107 13.5324 17.5568 12.9804C17.3893 12.431 16.7874 11.6329 15.9882 10.6872C15.5545 10.1486 14.905 9.56787 14.7077 9.27708C14.4314 8.90397 14.5105 8.73845 14.7077 8.4065C14.7077 8.4065 16.9736 5.04766 17.2099 3.90687C17.3289 3.49261 17.2099 3.1875 16.6471 3.1875H14.7877C14.3149 3.1875 14.0964 3.45055 13.9782 3.74134C13.9782 3.74134 13.0328 6.16697 11.6929 7.74261C11.2593 8.19892 11.062 8.34476 10.8256 8.34476C10.7075 8.34476 10.5366 8.19892 10.5366 7.78466V3.90687C10.5366 3.40939 10.3997 3.1875 10.0052 3.1875H7.08214C6.78712 3.1875 6.60942 3.41834 6.60942 3.63755C6.60942 4.10908 7.27939 4.21824 7.34826 5.54513V8.42708C7.34826 9.05966 7.24028 9.17418 7.00307 9.17418C6.37306 9.17418 4.83927 6.73692 3.92954 3.94892C3.751 3.40671 3.57245 3.1875 3.09718 3.1875Z" fill="#082E74"/>
                        <defs>
                        <rect width="17" height="17" fill="white" transform="translate(0.600098)"/>
                        </defs>
                    </svg>
                    `,
                    href: 'https://vk.com/oilgasforum_tnf',
                    name: 'VK',
                },
                {
                    icon: `<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.0309 5.70935C17.0309 5.70935 16.8648 4.56365 16.3535 4.06057C15.7061 3.39847 14.9822 3.39522 14.6502 3.35627C12.2729 3.1875 8.70352 3.1875 8.70352 3.1875H8.69687C8.69687 3.1875 5.12754 3.1875 2.7502 3.35627C2.41816 3.39522 1.69434 3.39847 1.04688 4.06057C0.535547 4.56365 0.372852 5.70935 0.372852 5.70935C0.372852 5.70935 0.200195 7.05629 0.200195 8.39998V9.65928C0.200195 11.003 0.369531 12.3499 0.369531 12.3499C0.369531 12.3499 0.535547 13.4956 1.04355 13.9987C1.69102 14.6608 2.54102 14.6381 2.91953 14.7095C4.28086 14.8361 8.7002 14.875 8.7002 14.875C8.7002 14.875 12.2729 14.8685 14.6502 14.703C14.9822 14.664 15.7061 14.6608 16.3535 13.9987C16.8648 13.4956 17.0309 12.3499 17.0309 12.3499C17.0309 12.3499 17.2002 11.0062 17.2002 9.65928V8.39998C17.2002 7.05629 17.0309 5.70935 17.0309 5.70935ZM6.94375 11.188V6.51751L11.5357 8.86085L6.94375 11.188Z" fill="#082E74"/>
                        <defs>
                        <rect width="17" height="17" fill="white" transform="translate(0.200195)"/>
                        </defs>
                    </svg>
                    `,
                    href: 'https://www.youtube.com/channel/UCxiZZMIETcM-X0r1s3Bo97w',
                    name: 'Youtube',
                },
            ],
            copyrightYear: new Date().getFullYear(),
            privacy: '/privacy/',
            oferta:
                siteSettings.data?.contacts_default_document_oferta &&
                siteSettings.data?.contacts_default_document_oferta.src
                    ? {
                          href: siteSettings.data?.contacts_default_document_oferta.src,
                          name: siteSettings.data?.contacts_default_document_oferta.title,
                      }
                    : {
                          href: '/docs/dogovor-oferta-tnf.pdf',
                          name: 'Лицензионный договор - оферта',
                      },
            support: siteSettings.data?.contacts_default_support_link || 'https://t.me/TnfChatBot',
        },
    };
};
